/**
 * Duration helpers — parse "1d", "2h", etc. → seconds.
 */
export function parseDurationToSeconds(input: string): number | null {
  const m = input.trim().match(/^(\d+(?:\.\d+)?)\s*(s|m|h|d)$/i);
  if (!m || !m[1] || !m[2]) return null;
  const value = parseFloat(m[1]);
  if (!Number.isFinite(value) || value <= 0) return null;
  const unit = m[2].toLowerCase();
  const multiplier =
    unit === "s" ? 1 : unit === "m" ? 60 : unit === "h" ? 3600 : 86400;
  return Math.floor(value * multiplier);
}

export function formatDwellDuration(seconds: number): string {
  const DAY = 86_400;
  const HOUR = 3_600;
  if (seconds >= DAY) {
    const days = seconds / DAY;
    return `${days.toFixed(days >= 10 ? 0 : 1)}d`;
  }
  if (seconds >= HOUR) {
    const hours = seconds / HOUR;
    return `${hours.toFixed(hours >= 10 ? 0 : 1)}h`;
  }
  if (seconds >= 60) {
    const minutes = seconds / 60;
    return `${minutes.toFixed(minutes >= 10 ? 0 : 1)}m`;
  }
  return `${seconds}s`;
}
